<template>
  <div class="modal-backdrop">
    <div class="modal-content">
      <h3>Seleccionar capas</h3>
      
      <div class="layers-list">
        <div v-for="(category, index) in categories" :key="index" class="category-item">
          <!-- Categoría -->
          <div class="category-header">
            <strong>{{ category.name }}</strong>
          </div>
          
          <!-- Capas de la categoría -->
          <div class="layer-items">
            <div v-for="layer in category.layers" :key="layer.id" class="layer-item">
              <label>
                <input 
                  type="checkbox" 
                  :value="layer.id" 
                  v-model="internalSelectedLayers"
                >
                {{ layer.name }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button class="btn-cancel" @click="$emit('close')">Cancelar</button>
        <button class="btn-save" @click="saveSelection">Guardar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeoprocesoSeleccionCapas',
  props: {
    selectedLayers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalSelectedLayers: [],
    };
  },
  computed: {
    categories() {
      // Obtener capas desde el store
      return this.$store.getters.getLayers || [];
    },
  },
  mounted() {
    // Inicializar con las capas ya seleccionadas
    this.internalSelectedLayers = [...this.selectedLayers];
  },
  methods: {
    saveSelection() {
      this.$emit('save', this.internalSelectedLayers);
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.layers-list {
  flex: 1;
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.category-item {
  margin-bottom: 15px;
}

.category-header {
  margin-bottom: 5px;
  color: #0056b3;
}

.layer-item {
  margin-left: 15px;
  margin-bottom: 3px;
}

.layer-item label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

button {
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: bold;
}

.btn-cancel {
  background: #ccc;
  color: #333;
}

.btn-save {
  background: #0056b3;
  color: white;
}

.btn-save:hover {
  background: #004494;
}
</style>
